export default "__VITE_ASSET__BLIRUMJ3__"